export default __webpack_public_path__ + "static/hm-4eb757696cfc9527064f523289eeb114.png";